import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckBoxEmpty = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M28 31H12C11.2044 31 10.4413 30.6839 9.87868 30.1213C9.31607 29.5587 9 28.7956 9 28V12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9H28C28.7956 9 29.5587 9.31607 30.1213 9.87868C30.6839 10.4413 31 11.2044 31 12V28C31 28.7956 30.6839 29.5587 30.1213 30.1213C29.5587 30.6839 28.7956 31 28 31ZM12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V28C11 28.2652 11.1054 28.5196 11.2929 28.7071C11.4804 28.8946 11.7348 29 12 29H28C28.2652 29 28.5196 28.8946 28.7071 28.7071C28.8946 28.5196 29 28.2652 29 28V12C29 11.7348 28.8946 11.4804 28.7071 11.2929C28.5196 11.1054 28.2652 11 28 11H12Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCheckBoxEmpty);
export default ForwardRef;
